import { useEffect, useState } from "react"
import { auth } from "../../../Firebase/config"
import { signOut, signInWithCustomToken } from "firebase/auth"
import { useNavigate } from "react-router-dom"
import Notify from "../Usenotifications"
import axios from "axios"

export const LoginHook = () => {
  const navigate = useNavigate()
  const [name, setName] = useState("") // Username field
  const [password, setPassword] = useState("") // Password field
  const [pressed, setPressed] = useState(false) // Loading state

  // Handle username change
  const onchangeName = (e) => {
    setName(e.target.value)
  }

  // Handle password change
  const onchangePassword = (e) => {
    setPassword(e.target.value)
  }

  // Handle form submission
  const onSubmit = async (e) => {
    e.preventDefault()
    setPressed(true)

    try {
      // 🔹 Ensure old Firebase session is cleared before signing in
      await signOut(auth)

      // 🔹 Call backend to validate credentials and get custom token
      const response = await axios.post(
        `/api/login`,
        {
          username: name,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true, // ✅ Important for cookies
        }
      )

      const { user, customToken } = response.data

      if (!user || !customToken) {
        throw new Error("Invalid response from server.")
      }

      const userCredential = await signInWithCustomToken(auth, customToken)
      const firebaseUser = userCredential.user

      const idToken = await firebaseUser.getIdToken(true)

      // ✅ Step 4: Send ID Token to backend for verification & store in secure cookies
      await axios.post(
        "/api/set-cookie",
        {},
        {
          headers: { Authorization: `Bearer ${idToken}` },
          withCredentials: true,
        }
      )
      localStorage.setItem("user", JSON.stringify(user))
      // 🔹 Notify user
      Notify("Logging you in", "success")

      // 🔹 Role-based redirection
      if (user.role === "Manager") {
        setTimeout(() => navigate("/dineinorders"), 1000)
      } else if (user.role === "Staff") {
        setTimeout(() => navigate("/Staffpage/status"), 1000)
      } else if (user.role === "Driver") {
        setTimeout(() => navigate("/Driver"), 1000)
      } else {
        throw new Error("Unauthorized access detected.")
      }
    } catch (error) {
      // 🔹 Extract specific error messages
      const errorMessage =
        error.response?.data?.message || error.message || "Login failed."

      Notify(errorMessage, "error")

      // 🔹 Ensure Firebase session is cleared if login fails
      await signOut(auth)
    } finally {
      setPressed(false)
    }
  }

  useEffect(() => {
    // Clear localStorage when navigating to the login page
    localStorage.removeItem("user")
  }, [])

  return [name, password, onchangeName, onchangePassword, onSubmit, pressed]
}
